import React, { useState } from 'react';
import {CloseCircleTwoTone, DownOutlined} from "@ant-design/icons"
import {Button, Tooltip} from "antd"
import {useDispatch} from "react-redux"
import {excludeEffect, sort} from "redux/graphSlice"
import EffectInfo from "components/graph/EffectInfo"
import { useTranslation } from 'react-i18next';

function isTouchDevice() {
	return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

export default function EffectHeader({ effect, width }) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [sortTooltipVisible, setSortTooltipVisible] = useState(false);
	const [sortTapped, setSortTapped] = useState(false);
	const [removeTooltipVisible, setRemoveTooltipVisible] = useState(false);
	const [removeTapped, setRemoveTapped] = useState(false);
	const isTouch = isTouchDevice();

	const handleSortClick = () => {
		if (isTouch && !sortTapped) {
			setSortTooltipVisible(true);
			setSortTapped(true);
		} else {
			dispatch(sort(effect));
			if (isTouch) {
				setSortTooltipVisible(false);
				setSortTapped(false);
			}
		}
	};

	const handleRemoveClick = () => {
		if (isTouch && !removeTapped) {
			setRemoveTooltipVisible(true);
			setRemoveTapped(true);
		} else {
			dispatch(excludeEffect(effect));
			if (isTouch) {
				setRemoveTooltipVisible(false);
				setRemoveTapped(false);
			}
		}
	};

	const removeButton = effect === "EFFICACY" ? <div/> :
		<Tooltip title={t('tooltips.removeSideEffect')} showArrow={false} placement="top" visible={isTouch ? removeTooltipVisible : undefined} onVisibleChange={isTouch ? (visible) => setRemoveTooltipVisible(visible) : undefined}>
			<Button className="effect-exclude-button" size="large" type="text" onClick={handleRemoveClick}>
				<CloseCircleTwoTone twoToneColor="#ff0000"/>
			</Button>
		</Tooltip>;

	return (
		<div className={`effect-header ${effect}`} style={{ width: width }}>
			<Tooltip title={`${t('tooltips.orderDrugsBy')} ${t(effect).toLowerCase()}`} showArrow={false} placement="top" visible={isTouch ? sortTooltipVisible : undefined} onVisibleChange={isTouch ? (visible) => setSortTooltipVisible(visible) : undefined}>
				<Button className="sort-button" size="large" type="text" onClick={handleSortClick}>
					<DownOutlined/>
				</Button>
			</Tooltip>
			<EffectInfo effect={effect}/>
			{removeButton}
		</div>
	);
}
